/**
 * ガス設備関連情報取得API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *S
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス設備情報
 */
export interface Sgkb502aReqGasEquipmentinformationDto {
    /** 
     * 供給地点特定番号：半角英数混在
     */
    suppntSpno?: string;
    /** 
     * 供給地点情報照会フラグ：真偽値
     */
    suppntInfoRefflg?: boolean;
}

